<template>
  <div id="multiselectnote">
    <div class="dropdown dropdown-filter" @click="showDropdown">
      <div class="overselect"></div>
      <div class="c-form-input">
        <h3 class="raleway-semi-p13">Votre expérience culinaire</h3>
        <img src="../../images/Fleche haut.svg" v-set-alt v-if="show" />
        <img src="../../images/flechebas-simple.svg" v-set-alt v-else />
      </div>
    </div>
    <div class="multiselect" v-if="show">
      <ul>
        <div class="row-selectoptions mt-3"  :class="{ row: !isPhone }">
          <div :class="{ 'col-10': !isPhone }">
            <li>
              <input type="checkbox" id="Délice" :value="false" v-model="selected" />
              <label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="Délice">
                Délice au Réveil - Petit déjeuner inclus <span v-if="getExperienceCount('delice')" class="filter-count">({{ getExperienceCount('delice') }})</span>
              </label>
            </li>
            <li>
              <input type="checkbox" id="Escapade" :value="false" v-model="selected2" />
              <label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="Escapade">
                Escapade Gourmande - Demi-pension <span v-if="getExperienceCount('escapade')" class="filter-count">({{ getExperienceCount('escapade') }})</span>
              </label>
            </li>
            <li>
              <input type="checkbox" id="Évasion" :value="false" v-model="selected3" />
              <label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="Évasion">
                Évasion Culinaire - Pension complète <span v-if="getExperienceCount('evasion')" class="filter-count">({{ getExperienceCount('evasion') }})</span>
              </label>
            </li>
            <li>
              <input type="checkbox" id="Plaisirs" :value="false" v-model="selected4" />
              <label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="Plaisirs">
                Plaisirs Illimités - Tout inclus <span v-if="getExperienceCount('plaisirs')" class="filter-count">({{ getExperienceCount('plaisirs') }})</span>
              </label>
            </li>
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import fetcher from 'packs/shared/api.js';

export default {
  name: 'multiselectexperience',
  props: ['options', 'filterCounts'],
  data() {
    return {
      show: false,
      selected: false,
      selected2: false,
      selected3: false,
      selected4: false,

    };
  },
  methods: {
    showDropdown() {
      this.show = !this.show;
    },
    getExperienceCount(experienceType) {
      if (!this.filterCounts) return 0;
      
      const fieldName = `has_${experienceType}`;
      const experienceData = this.filterCounts[fieldName];
      
      if (!experienceData) return 0;
      
      // Find the count for true values (lodgings that have this experience)
      const trueData = experienceData.find(item => item.key === 1);
      return trueData ? trueData.count : 0;
    },
  },

  watch: {
    selected(val) {
      this.$emit('checked', val, 'delice');
    },
    selected2(val) {
      this.$emit('checked', val, 'escapade');
    },
    selected3(val) {
      this.$emit('checked', val, 'evasion');
    },
    selected4(val) {
      this.$emit('checked', val, 'plaisirs');
    },
  },
  computed: {
    isPhone() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
  }
};
</script>

<style lang="scss" scope="app/assets/stylesheets/components/lodging-filter">
.filter-count {
  color: #666;
  font-size: 0.9em;
  font-weight: normal;
  margin-left: 4px;
}
</style>
